import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { TbAlertTriangle } from 'react-icons/tb'
import React from 'react'

const ConfirmDeleteDialog = ({ isOpen, onClose, onDelete, deleteLoading, header, description, showWarning }) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <TbAlertTriangle className="h-5 w-5 text-red-500" />
            <span>{header}</span>
          </DialogTitle>
        </DialogHeader>
        <DialogDescription>
          <p className="text-primary">{description}</p>
          {showWarning && (
            <p className="mt-3 text-xs text-muted-foreground italic">This action cannot be undone and should be used with caution.</p>
          )}
        </DialogDescription>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancel</Button>
          <Button variant="destructive" onClick={onDelete} disabled={deleteLoading}>
            {deleteLoading ? (
              "Deleting..."
            ) : (
              "Delete"
            )}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default ConfirmDeleteDialog